// @mui material components
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

// Material Kit 2 React components
import MKBox from 'components/MKBox';
import MKTypography from 'components/MKTypography';

// Material Kit 2 React components
import TransparentBlogCard from 'examples/Cards/BlogCards/TransparentBlogCard';

import data from 'csdd_data/newsAndInsights';

import slug from 'slug';

function NewsAndInsights() {
  return (
    <MKBox component='section' py={2}>
      <Container>
        <MKTypography textGradient variant='h2' mb={1} mt={1}>
          News & Insights
        </MKTypography>
        <MKTypography variant='body1' color='text' mb={6}>
          Your Daily Dose of Insight.
        </MKTypography>
        {data.length === 0 ? (
          <MKTypography textAlign='center' color='warning'>
            News is not available at the moment.
          </MKTypography>
        ) : (
          <Grid container spacing={3}>
            {data.map((article) => {
              return (
                <Grid item xs={12} sm={6} lg={4} key={article.title}>
                  <TransparentBlogCard
                    image={article.headerImage}
                    title={article.title}
                    description={article.description}
                    action={{
                      type: 'internal',
                      route: `/news/${slug(article.title)}`,
                      color: 'error',
                      label: 'read more',
                    }}
                  />
                </Grid>
              );
            })}
          </Grid>
        )}
      </Container>
    </MKBox>
  );
}

export default NewsAndInsights;
